import { useContext, useState } from 'preact/hooks'
import { h, FunctionComponent } from 'preact'

import { RatingField as RatingFieldType, FieldLayout } from 'scripts/type'

import FieldsContext from '../fieldsContext'
import FieldWrapper from '../components/FieldWrapper'
import Normal from './Normal'
import Compact from './Compact'
import { FieldCommonProps } from '../type'
import { useHandlersWithRequired } from '../hooks'
import usePropValueChange from 'components/business/SurveyForm/Fields/hooks/usePropValueChange'

const RatingField: FunctionComponent<FieldCommonProps> = (props) => {
  const { field, required, onFieldSubmit } = props
  const [value, setValue] = useState<number | null>(null)
  const { isMultipleFields } = useContext(FieldsContext)!
  const { onNext } = useHandlersWithRequired(setValue, required, onFieldSubmit)
  const { layout } = field as RatingFieldType
  const isCompactLayout = layout === FieldLayout.Compact
  usePropValueChange(props, () => setValue(null))

  const onClick = (inputValue: number) => {
    if (!isMultipleFields && value) {
      return
    }
    setValue(inputValue)
    ;(isMultipleFields || required) && setTimeout(onNext, 0)
  }

  return (
    <FieldWrapper field={field} handlerProps={{ visible: !required, onNext }}>
      {isCompactLayout ? <Compact {...props} onSelect={onClick} /> : <Normal {...props} onSelect={onClick} />}
    </FieldWrapper>
  )
}

export default RatingField
